import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
/**
 * formatRankForDisplay
 * Removes leading zeros from a numerical segment and returns a string with a trailing dot
 * @param value - The value to trim leading zeros from
 * @returns The value with leading zeros removed
 * @example formatRankForDisplay("02.002.0003") -> "2.2.3."
 * @example formatRankForDisplay("02") -> "2."
 * @example formatRankForDisplay('002.002..22..000.2...') -> "2.2.22.2."
 */
function formatRankForDisplay(value) {
  return value.toString()
  // Remove leading zeros
  .replace(/^0+|(\D)0+/g, '$1')
  // Remove multiple dots
  .replace(/\.{2,}/g, '.')
  // Append a dot to the end if it doesn't already end with one
  .replace(/([^.])$/, '$1.');
}
export default formatRankForDisplay;